export default {"src":"/_next/static/media/dai.ba6d3142.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};